'use strict';

var Requests = {};

var defaultDomains = [
    'localhost',

    'trovis-team.com',
    'www.trovis-team.com',
    'samson.trovis-team.com',

    'trovis.de',
    'www.trovis.de',
    'samson.trovis.de',
];

var baseDomains = ['.test.sam-digital.net', '.sam-digital.net', '.trovis-team.com', '.trovis.de'];

Requests.getSubdomain = function (location) {
    // cleanup
    location = location.toLowerCase().trim();

    // remove port (if included in location)
    var idxCut = location.indexOf(':');
    idxCut = idxCut == -1 ? location.length : idxCut;

    location = location.substring(0, idxCut);

    // determine subdomain ..

    // 1. default location?
    if (_.indexOf(defaultDomains, location) != -1) {
        return '';
    }

    // 2. unknown base URL?
    var validBaseDomain = false;
    _.each(baseDomains, function (b) {
        if (location.indexOf(b, location.length - b.length) !== -1) {
            validBaseDomain = true;
        }
    });
    if (!validBaseDomain) {
        return '';
    }

    // 3. split parts and return first element
    var parts = location.split('.');
    if (parts.length != 3 && !(parts.length == 4 && parts[1] == 'test')) {
        return '';
    }

    return parts[0];
};

Requests.getSchemaURLs = function (id, type, schema) {
    var requestPrefix = '/api/v1/devices/' + id;
    var subdomain = this.getSubdomain(window.location.host) || 'samson';
    var fileSchemaSuffix = schema + '.svg';

    return _.compact([
        // .. device specific custom schema file
        requestPrefix + '/scheme/db' + id + '.svg',
        // .. device specific custom schema file with schema-type suffix
        requestPrefix + '/scheme/db' + id + (schema === '' ? '' : '-') + fileSchemaSuffix,
        // .. company specific custom schema file
        requestPrefix + '/scheme/c-' + subdomain + (schema === '' ? '' : '-') + fileSchemaSuffix,
        // .. type specific schema file
        requestPrefix + '/scheme/' + type + (schema === '' ? '' : '-') + fileSchemaSuffix,
        // .. default schema file
        fileSchemaSuffix != '.svg' ? requestPrefix + '/scheme/' + fileSchemaSuffix : '',
        // .. placeholder schema file
        requestPrefix + '/scheme/blank.svg', // i18n.TR('Aktuell kein Anlagenschema verfügbar.')
    ]);
};

Requests.getLanguagesURLs = function () {
    var subdomain = this.getSubdomain(window.location.host) || 'samson';

    return _.compact([
        // .. company specific file
        '/lang/' + subdomain + '/languages.json',
        // .. default API call
        '/api/v1/account/languages',
    ]);
};

Requests.getLocalizationURLs = function (langCode, type) {
    var subdomain = this.getSubdomain(window.location.host) || 'samson';
    var fileName = type.replace('%', langCode);

    return _.compact([
        // .. company specific file
        '/lang/' + subdomain + '/' + fileName,
        // .. default file
        '/lang/' + fileName,
    ]);
};

Requests.getMetaInfoURLs = function (langCode, type) {
    var subdomain = this.getSubdomain(window.location.host) || 'samson';
    type = type + '_';

    return _.compact([
        // .. company specific file
        '/info/' + subdomain + '/' + type + langCode + '.json',
        // .. company specific file
        '/info/' + subdomain + '/' + type + 'en.json',
        // .. default language specific file
        '/info/' + type + langCode + '.json',
        // .. fallback: EN
        '/info/' + type + 'en.json',
    ]);
};

// Query all URLs from specified list. Invoke success callback with result if request is successful.
// If all URLs fail the error callback is invoked.
Requests.firstURLfromList = function (urlList, successCB, errorCB, mode) {
    mode = mode || 'json';

    var urlRequest = $.Deferred();

    var loadURL = function (i) {
        if (i == urlList.length) {
            // no more URLs available -> fail
            urlRequest.reject();
            return;
        }

        $.get(
            urlList[i] + '?_=' + Date.now(), // prevent browser caching
            function (data) {
                urlRequest.resolve(data, urlList[i]);
            },
            mode
        ).fail(function () {
            loadURL(i + 1);
        });
    };

    loadURL(0);
    $.when(urlRequest)
        .done(function (result, url) {
            successCB(result, url);
        })
        .fail(function () {
            errorCB();
        });
};

module.exports = Requests;
